import ButtonRedirect from "./ButtonRedirect";

export default ButtonRedirect;
